import config from "../config";
import { http, httpFormData } from "../framework/api";

/**
 * Validates a verification hash (anonymous).
 * @param {string} hash
 */
export const validateVerificationHash = (hash) => () => {
  const url = `${config.API_ROOT_URL}/email-verification/${hash}/validate`;
  return http("GET", url, null, false);
};

/**
 * Sets verification status to ManualVerificationNeeded via hash (anonymous).
 * @param {string} hash
 */
export const requestManualReviewAnonymous = (hash) => () => {
  const url = `${config.API_ROOT_URL}/email-verification/${hash}/request-manual-review`;
  return http("POST", url, null, false);
};

/**
 * Validates selfie quality via verification hash (anonymous).
 * @param {string} hash
 * @param {File} selfieFile
 */
export const validateSelfieAnonymous = (hash, selfieFile) => () => {
  const formData = new FormData();
  formData.append("selfie", selfieFile);
  const url = `${config.API_ROOT_URL}/email-verification/${hash}/validate-selfie`;
  return httpFormData("POST", url, formData, false);
};

/**
 * Analyzes ID document via verification hash (anonymous).
 * @param {string} hash
 * @param {File} idImageFile
 */
export const analyzeDocumentAnonymous = (hash, idImageFile) => () => {
  const formData = new FormData();
  formData.append("idImage", idImageFile);
  const url = `${config.API_ROOT_URL}/email-verification/${hash}/analyze-document`;
  return httpFormData("POST", url, formData, false);
};
